import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import imgneonatal from '../img/uti-neonatal.jpg'
import imgcamas from '../img/referencia.jpg'
import imgrecem from '../img/simulacao.jpg'
import imgalta from '../img/alta.jpg'
import imgDoctors from '../img/equipe.png'
import PageHeader from '../components/PageHeader'
import PageEye from '../components/PageEye'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }
  strong {
    color: ${colors.lilas};
  }
  a {
    color: ${colors.amarelo};
  }

  .lista {
    h2 {
      color: ${colors.verde}!important;
    }
    ol {
      padding: 0;
      margin: 0 0 0 2em;
      display: flex;
      flex-wrap: wrap;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: block !important;
      }
      li {
        margin: 0 1em 1em 3px;
        padding: 1em;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 100%;
        color: ${colors.verde};
        font-size: 30px;
        p {
          color: ${colors.cinza};
          font-size: 0.7em;
          margin: 0;
        }
        @media ${device.mobileL} {
          width: 100%;
          padding: 1em;
          margin: 0 0 1em 0;
        }
        svg {
          position: absolute;
          left: 25px;
          top: 32px;
          font-size: 1.8em;
          color: ${colors.verde};
        }
      }
    }
  }
  .inner {
    justify-content: space-between;
    p {
      font-size: 0.8em;
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    h2 {
      color: #8e8fc7;
      margin-top: 0;
    }
    .maternidade {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 40px 0;
      padding: 0;
      @media ${device.mobileL} {
        margin: 40px 0 0;
      }
      div {
        padding: 2em;
        margin: 0 30px 30px 0;
        background-color: white;
        box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.5);
        width: 100%;
        box-sizing: border-box;
        @media ${device.mobileL} {
          width: 100%;
          margin: 0 0 30px 0;
        }
      }
      p {
        width: 100%;
        color: #4a4a4a;
        text-align: left;
        position: relative;
        top: 0em;
      }
      @media ${device.mobileL} {
        flex-wrap: wrap;
      }
    }
    .probtrat {
      box-shadow: 1px 1px 10px #516d6e;
      margin-bottom: 20px;
      padding: 2em;
      color: #ffffff;
      background: ${colors.verdeGradiente};
      strong {
        color: #ffffff;
      }
      h3 {
        font-size: 1em;
        position: relative;
        color: ${colors.amarelo};
        margin-bottom: 2em;
        :before {
          position: absolute;
          content: '';
          top: -10px;
          left: 0;
          border: 1px solid #539e9f;
          width: 30px;
          opacity: 0.5;
          @media ${device.mobileL} {
            left: 45%;
          }
        }
        :after {
          position: absolute;
          content: '';
          bottom: -10px;
          left: 0;
          border: 1px solid #539e9f;
          width: 30px;
          opacity: 0.5;
          @media ${device.mobileL} {
            left: 45%;
          }
        }
      }
      p {
        padding-bottom: 10px;
      }
      div {
        margin-bottom: 25px;
      }
    }
    li {
      font-size: 1em;
      text-align: left;
    }
    .estrutura {
      display: flex;
      align-items: center;
      padding-top: 0;
      div {
        width: 50%;
        :nth-child(1) {
          padding-right: 60px;
          @media ${device.mobileL} {
            padding-bottom: 40px;
          }
        }
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        width: 100%;
        margin: 0;
      }
      @media ${device.mobileL} {
        display: inline;
        justify-content: center;
      }
    }

    .atendimento {
      p {
        display: inline;
        color: #ffffff;
        font-size: 0.8em;
      }
      .tel {
        display: flex;
        text-justify: top;
        p {
          margin: 0 0 0 5px;
          @media ${device.mobileL} {
            display: block;
          }
        }
      }
      .central {
        display: flex;
        align-items: center;
        h3 {
          color: #4a4a4a;
        }
        p {
          display: block;
          margin: 2px;
        }
        div {
          width: 100%;
          @media ${device.mobileL} {
            display: block;
          }
        }
        .info {
          padding-left: 40px;
          @media ${device.mobileL} {
            padding: 0;
          }
          div {
            padding: 20px 0;
            h3 {
              margin: 5px 0;
            }
            a {
              color: #ffffff;
            }
          }
        }
        .map {
          width: 100%;
          height: 300px;
          border: 1px solid #148581;
          @media ${device.mobileL} {
            position: static;
            margin-bottom: 1em;
            width: 100%;
            height: 200px;
          }
        }
        @media ${device.mobileL} {
          display: block;
        }
      }
    }
  }

  :nth-of-type(3) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    margin-bottom: 1em;
    h2 {
      color: #ffffff;
    }
  }
  :nth-of-type(5) {
    padding-top: 0;
    a {
      color: ${colors.lilas};
    }
    p {
      font-size: 0.8em;
      line-height: 1.5em;
    }
    .estrutura {
      justify-content: space-between;
      div {
        width: 55%;
        @media ${device.mobileL} {
          width: 100%;
          padding-top: 30px;
        }
      }
      .gatsby-image-wrapper {
        width: 35%;
        div {
          padding-bottom: 94% !important;
        }
        img {
          width: 100%;
          object-fit: none;
          @media ${device.mobileL} {
            width: 100%;
          }
        }
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        width: 41%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
  }
  :nth-of-type(6) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
    h2 {
      color: #fff8d1;
    }
  }
  :nth-of-type(7) {
    h2 {
      color: ${colors.verde};
    }
  }
  :nth-of-type(8) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    li {
      font-size: 0.8em;
      text-align: left;
    }
    h2 {
      color: #ffffff;
    }

    .estrutura {
      justify-content: space-between;
      div {
        width: 55%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .gatsby-image-wrapper {
        width: 41%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        width: 41%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      padding-bottom: 30px;
    }
  }
  :nth-of-type(9) {
    h2 {
      color: #fa7373;
    }
  }
  :nth-of-type(10) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    h2 {
      color: #ffffff;
    }
    .estrutura {
      padding-bottom: 30px;
    }
  }
`

export const CentrodeCirurgiaNeonatalTemplate = ({
  title,
  content,
  image,
  slug,
  color,
  area = 'Centros e Serviços',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          height="204px"
        />
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[0].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[0].texto)}</div>
              {sessoes[0].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[0].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Bola suíça"
                  className="offsetImgEnd"
                />
              ) : (
                <img
                  src={sessoes[0].imagemDaSessao.sourceUrl}
                  alt="Bola suíça"
                  className="offsetImgEnd"
                />
              )}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[1].tituloDaSessao)}</h2>
            {parse(sessoes[1].texto)}
          </div>
        </GroupContent>

        <PageEye
          title={sessoes[2].tituloDaSessao}
          content={sessoes[2].texto}
          image={sessoes[2].imagemDaSessao.sourceUrl}
          color="lilas-vermelho"
          height="274px"
          overflow="visible"
          titleWidth="525px"
          imgWidth="48%"
          right="5px"
          bottom="0px"
        />
        <GroupContent>
          <div className="center">
            <div>{parse(sessoes[3].texto)}</div>
          </div>
          <div className="inner center">
            <div className="estrutura">
              {sessoes[4].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[4].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Recem nascido"
                  className="offsetImgEnd2"
                />
              ) : (
                <img
                  src={sessoes[4].imagemDaSessao.sourceUrl}
                  alt="Recem nascido"
                  className="offsetImgEnd2"
                />
              )}
              <div>{parse(sessoes[4].texto)}</div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
            {parse(sessoes[5].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[6].tituloDaSessao)}</h2>
            <div className=" maternidade prolapso">
              {sessoes[6].listaDeItens.map((item, index) => (
                <div key={index}>{parse(item.item)}</div>
              ))}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[7].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[7].texto)}</div>
              {sessoes[7].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[7].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Neo Natal"
                  className="offsetImgEnd3"
                />
              ) : (
                <img
                  src={sessoes[7].imagemDaSessao.sourceUrl}
                  alt="Neo Natal"
                  className="offsetImgEnd3"
                />
              )}
            </div>
            {parse(sessoes[8].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[9].tituloDaSessao)}</h2>
              <div className="probtrat">
                <h3>{parse(sessoes[10].tituloDaSessao)}</h3>
                {sessoes[10].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              <div className="probtrat">
                <h3>{parse(sessoes[11].tituloDaSessao)}</h3>
                {sessoes[11].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              <div className="probtrat">
                <h3>{parse(sessoes[12].tituloDaSessao)}</h3>
                {sessoes[12].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              <div className="probtrat">
                <h3>{parse(sessoes[13].tituloDaSessao)}</h3>
                {sessoes[13].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              <div className="probtrat">
                <h3>{parse(sessoes[14].tituloDaSessao)}</h3>
                {sessoes[14].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              {parse(sessoes[15].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h2>{parse(sessoes[16].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[16].texto)}</div>

              {sessoes[16].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[16].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="bebê"
                  className="offsetImgEnd3"
                />
              ) : (
                <img
                  src={sessoes[16].imagemDaSessao.sourceUrl}
                  alt="bebê"
                  className="offsetImgEnd3"
                />
              )}
            </div>
            <h2>{parse(sessoes[17].tituloDaSessao)}</h2>
            {parse(sessoes[17].texto)}
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

CentrodeCirurgiaNeonatalTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CentrodeCirurgiaNeonatal = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CentrodeCirurgiaNeonatalTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

CentrodeCirurgiaNeonatal.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CentrodeCirurgiaNeonatal

export const CentrodeCirurgiaNeonatalQuery = graphql`
  query CentrodeCirurgiaNeonatalById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          acordeao {
            titulo
            conteudo
          }
          linksExternos {
            descricao
            titulo
            url
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
